"use strict";

import Vue from 'vue';
import axios from "axios";
import store from '../store'
import router from "../router/router";

import {Toast, Notify, Dialog} from 'vant';

Vue.use(Toast).use(Notify).use(Dialog)

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
    baseURL: process.env.baseURL || process.env.VUE_APP_API || "",
    timeout: 60 * 1000, // Timeout
    withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
    function (config) {
        // Do something before request is sent
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// Add a response interceptor
_axios.interceptors.response.use(
    function (response) {
        // Do something with response data
        const code = response.data.code;
        if(code === 324){
            return response.data;
        }
        if (code < 200 || code > 300) {
            Notify({
                message: response.data.message,
                duration: 2500,
                background: '#F76C6C'
            });
            // Toast.fail(response.data.message);
            if (code === 1201) {
                store.dispatch('LogOut').then(() => {
                    router.push('/login');
                })
            }
            return Promise.reject('error');
        } else {
            return response.data;
        }
    },
    function (error) {
        // Do something with response error
        let code = 0;
        try {
            code = error.response.data.status;
        } catch (e) {
            if (error.toString().indexOf('Error: timeout') !== -1) {
                Notify({
                    message: '网络请求超时',
                    duration: 2500,
                    background: '#F76C6C'
                });
                return Promise.reject(error);
            }
            if (error.toString().indexOf('Error: Network Error') !== -1) {
                //+error.config.url
                Notify({
                    message: '网络请求错误',
                    duration: 2500,
                    background: '#F76C6C'
                });
                return Promise.reject(error);
            }
        }
        if (code === 401) {
            Dialog.alert({
                message: '登录状态已过期，您可以继续留在该页面，或者重新登录',
                title: '系统提示',
                confirmButtonText: '重新登录',
                cancelButtonText: '取消'
            }).then(() => {
                store.dispatch('LogOut').then(() => {
                    location.reload(); // 为了重新实例化vue-router对象 避免bug
                });
            });
        } else if (code === 403) {
            Notify({
                message: '网络请求错误',
                duration: 2500,
                background: '#F76C6C'
            });
        } else {
            const errorMsg = error.response.data.message;
            if (errorMsg !== undefined) {
                Notify({
                    message: errorMsg,
                    duration: 2500,
                    background: '#F76C6C'
                });
            }
        }
        return Promise.reject(error);
    }
);

Plugin.install = function (Vue, options) {
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
        axios: {
            get() {
                return _axios;
            }
        },
        $axios: {
            get() {
                return _axios;
            }
        },
    });
};

Vue.use(Plugin)

export default Plugin;
